import { getPoseById } from '../poses/library'
import { useAppStore } from '../store'

export function DetailPanel() {
  const poseId = useAppStore((s) => s.poseId)
  const pose = getPoseById(poseId)
  if (!pose) return null

  return (
    <aside className="panel detail-panel">
      <div className="panel-header">
        <h2>{pose.english}</h2>
        <span className="badge">{pose.difficulty}</span>
      </div>
      <p className="sanskrit">{pose.sanskrit}</p>
      <p className="muted small">{pose.categories.join(' · ')}</p>

      <section>
        <h3>Alignment cues</h3>
        <ul>{pose.alignmentCues.map((c) => <li key={c}>{c}</li>)}</ul>
      </section>
      <section>
        <h3>Common mistakes</h3>
        <ul>{pose.commonMistakes.map((c) => <li key={c}>{c}</li>)}</ul>
      </section>
      <section>
        <h3>Precautions</h3>
        <ul>{pose.precautions.map((c) => <li key={c}>{c}</li>)}</ul>
      </section>
      <section>
        <h3>Evidence notes</h3>
        <p><strong>Visible anatomy:</strong> {pose.evidence.visibleAnatomy}</p>
        <p><strong>Plausible mechanisms:</strong> {pose.evidence.plausibleMechanisms}</p>
        <p><strong>Research-supported:</strong></p>
        {pose.evidence.researchSupported.length ? (
          <ul>
            {pose.evidence.researchSupported.map((r) => (
              <li key={r.url}>
                <a href={r.url} target="_blank" rel="noreferrer">{r.text}</a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No specific citation attached for this pose yet.</p>
        )}
        <p><strong>Unknown / variable:</strong> {pose.evidence.unknown}</p>
      </section>
    </aside>
  )
}
